import { LawArticle } from "../Model/LawArticle";
import { Query } from "../Model/Query";
export class LawArticleService {
    constructor(apiService, queryParamsFactory) {
        this.apiService = apiService;
        this.queryParamsFactory = queryParamsFactory;
    }
    async findOne(lawArticleId) {
        if (lawArticleId) {
            const response = await this.apiService.get('law_articles/' + lawArticleId);
            if (!response.ok) {
                throw new Error(`Error al obtener la ley`);
            }
            const content = await response.json();
            if (content) {
                return content;
            }
            return;
        }
        else {
            throw new Error(`Error al obtener LawId`);
        }
    }
    async findAllByLawGlobal(lawGlobalId) {
        if (lawGlobalId) {
            const response = await this.apiService.get(`article_by_law/${lawGlobalId}`);
            if (!response.ok) {
                throw new Error(`Error al obtener los articulos de una ley`);
            }
            const content = await response.json();
            if (content) {
                return content;
            }
            return;
        }
        else {
            throw new Error(`Error al obtener LawId`);
        }
    }
    async find(opts) {
        if (((opts === null || opts === void 0 ? void 0 : opts.offset) || opts.offset >= 0) && (opts === null || opts === void 0 ? void 0 : opts.limit)) {
            const query = new Query(opts.offset, opts.limit);
            //   if (opts.filters?.diligenceId) {
            //       query.addFilter('law_id', [opts.filters.diligenceId]);
            //   }
            //   if (opts.filters?.thirdId) {
            //     query.addFilter('third_id', [opts.filters.thirdId]);
            // }
            const params = this.queryParamsFactory.createQueryParams(query);
            const response = await this.apiService.get(`law_articles?${params}`);
            if (!response.ok) {
                throw new Error(`Error al obtener los terceros.`);
            }
            const content = await response.json();
            return content.map(lawArticle => new LawArticle(lawArticle).getState());
        }
        else {
            throw new Error(`Error al obtener opts.`);
        }
    }
}
